<template>
  <layout :title-text="title">
    <div slot="content" class="final-container">
      <q-input placeholder="请输入队伍名称"
        v-model="input"
        @change="search"
        class="input-with-select"
      >
        <i slot="prefix" class="q-input__icon q-icon-search"></i>
        <q-button slot="append" @click="search">搜索</q-button>
      </q-input>
      <div class="tabs">
        <div class="tabs-title">
            <ul>
                <li :class="{'show-title': active === resultType.Final}" @click="tabsClick(resultType.Final)">总决赛</li>
                <li :class="{'show-title': active === resultType.Half}" @click="tabsClick(resultType.Half)">半决赛</li>
            </ul>
        </div>
        <div class="tabs-text">
            <div class="text" :class="{'show' : active === resultType.Final}">
              <div class="text-content">
                <lmb-table ref="childfinaltable"/>
              </div>
            </div>
            <div class="text" :class="{'show' : active === resultType.Half}">
              <div class="text-content">
                <lmb-table ref="childtable" />
              </div>
            </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
import LmbTable from '@components/lmb-table'

const resultType = {
  Final: 1,
  Half: 2
}
export default {
  components: {
    Layout,
    LmbTable
  },
  data () {
    return {
      resultType,
      title: '决赛成绩',
      active: resultType.Final,
      input: '',
      tempName: ''
    }
  },
  methods: {
    tabsClick (index) {
      this.active = index
      if (this.active === 1) {
        this.$refs.childfinaltable.tabCheck(this.active)
      } else {
        this.$refs.childtable.tabCheck(this.active)
      }
    },
    search () {
      if (this.active === 1) {
        this.$refs.childfinaltable.getList(this.input)
      } else {
        this.$refs.childtable.getList(this.input)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.final-container {
  position: relative;
  margin: 0 auto;
  height: 685px;
  width: 1000px;
  color: white;
}
.q-input {
  width: 486px;
  i {
    width: 17px;
    height: 17px;
    color: #5891FA;
    line-height: 44px;
  }
}
/deep/ .q-input__inner::placeholder {
  color: #5891FA;
}
/deep/.q-button {
  width: 96px;
  height: 44px;
  background-color: #2548A0;
  color: #71A9FE;
  border: none;
  font-size: 14px;
}
/deep/ .q-input__inner {
  background-color: #02021C;
  border: 1px solid #5891FA;
  color:  #fff;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
}
.tabs{
  display: flex;
  width:100%;
  height: 558px;
  margin-top: 18px;
  background-color: #465ECC;
  .tabs-title{
    width: 194px;
    height: 100%;
    ul {
      margin: 0;
      padding: 0;
      border: none;
    }
    li{
      width: 156px;
      height: 80px;
      line-height: 80px;
      margin: 38px 19px;
      list-style: none;
      text-align: center;
      background-color: #243074;
      box-sizing: border-box;
      &:hover {
        background: url(../../assets/images/btn_final_result.png);
        color: #36E4FC;
      }
    }
  }
  .tabs-text {
    flex: 1;
    border: 1px solid #5891FA;
    padding: 2px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 24px;
    .text{
      background-color: #02021C;
      text-align: left;
      width:100%;
      height: 100%;
      display: none;
    }
    .show {
      display: block;
    }
  }
}
.show-title {
  background: url(../../assets/images/btn_final_result.png);
  color: #36E4FC;
}
.q-button {
  font-size: 16px !important;
  border: 1px solid #5891FA;
}
</style>
